import { observer } from 'mobx-react-lite'
import { useInfiniteScroll } from '@/hooks/infinite-scroll-hooks'
import { type ConversationViewModel } from '@/features/messaging/ConversationViewModel'
import { List } from '@/features/messaging/components/ConversationView/Messages/List'
import { MessageGroupContainer } from '@/features/messaging/components/ConversationView/Messages/List/MessageGroup/MessageGroupContainer'

export interface ListContainerProps {
  vm: ConversationViewModel
}

export const ListContainer = observer(function ListContainer({
  vm,
}: ListContainerProps) {
  const { connectRef } = useInfiniteScroll({ scroller: vm.scroller })

  return (
    <List scrollZoneRef={connectRef}>
      {vm.messageGroups.map((group) => (
        <MessageGroupContainer
          key={group.messages[0].message.id}
          group={group}
        />
      ))}
    </List>
  )
})
